import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconAmenitiesFireplaceComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 2c1 3 2.5 3.5 3.5 4.5A5 5 0 0 1 17 10a5 5 0 1 1-10 0c0-.3 0-.6.1-.9a2 2 0 1 0 3.3-2C8 4.5 11 2 12 2Z"
          fill="none"
        />
        <path d="m5 22 14-4" fill="none" />
        <path d="m5 18 14 4" fill="none" />
      </svg>
    </SvgIcon>
  );
};

IconAmenitiesFireplaceComponent.displayName = 'IconAmenitiesFireplace';

const IconAmenitiesFireplace = React.memo(IconAmenitiesFireplaceComponent);

export default IconAmenitiesFireplace;
